class AutomaticReleaseConstants {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'AutomaticReleaseConstants'

export const MBL_AUDIT = new AutomaticReleaseConstants(1, 'MBL放单审核', 'MBL Bill of Lading Audit')
export const HBL_AUDIT = new AutomaticReleaseConstants(2, 'HBL放单审核', 'HBL Bill of Lading Audit')
export const MBL_APPLY = new AutomaticReleaseConstants(3, 'MBL申请放单', 'MBL Bill of Lading Application')
export const HBL_APPLY = new AutomaticReleaseConstants(4, 'HBL申请放单', 'HBL Bill of Lading Application')
export const CHARGEABLE_AUDIT = new AutomaticReleaseConstants(5, '应收费用核销', 'Chargeable Expense Verification')
export const HBL_ORIGINAL_PRINTING = new AutomaticReleaseConstants(6, 'HBL正本打印', 'HBL Original Printing')
export const HBL_RECEPTION = new AutomaticReleaseConstants(7, 'HBL接收', 'HBL Reception')
export const MBL_RETRIEVE = new AutomaticReleaseConstants(8, 'MBL取回', 'MBL Retrieval')
export const MBL_RECEPTION = new AutomaticReleaseConstants(9, 'MBL接收', 'MBL Reception')
export const HBL_RETRIEVE = new AutomaticReleaseConstants(10, 'HBL取回', 'HBL Retrieval')
export const HBL_CLAIM = new AutomaticReleaseConstants(11, 'HBL认领', 'HBL Claim')
export const MBL_CLAIM = new AutomaticReleaseConstants(12, 'MBL认领', 'MBL Claim')
export const HBL_RELEASE = new AutomaticReleaseConstants(13, 'HBL放单', 'HBL Bill of Lading Release')
export const MBL_RELEASE = new AutomaticReleaseConstants(14, 'MBL放单', 'MBL Bill of Lading Release')
